/**
 * External dependencies
 */
import {  remove, get } from 'lodash';

/**
 * Internal dependencies
 */
import { editReport } from 'state/reports/actions';
import { getEditedReport } from 'state/reports/selectors';
import { getBuilderReportId } from 'state/ui/report-builder/selectors';

export default (dimension) => (dispatch, getState) => {
	let state = getState();
	let reportId = getBuilderReportId(state);
	let report = getEditedReport(state, reportId);

	if (!report) {
		return false;
	}

	let dimensions = get(report, 'config.dimensions', []);

	dimensions = remove([...dimensions], (m) => m !== dimension);

	dispatch(editReport(reportId, { config: { dimensions } }));
};
